import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const location = useLocation();

  return (
    <nav aria-label="面包屑导航" className="py-3 px-0">
      <ol className="flex flex-wrap items-center gap-1 text-sm">
        <li className="flex items-center">
          <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
            <i className="ri-home-4-line"></i>
            <span className="ml-1">首页</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            <i className="ri-arrow-right-s-line text-foreground-400 mx-1"></i>
            {item.href && index < items.length - 1 ? (
              <Link to={item.href} className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-900 font-medium whitespace-nowrap' : 'text-foreground-500 whitespace-nowrap'}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}